import Axios from 'axios';
import { route } from '@/api/apiRoute';

// 与正式派发的数据模态映射一致：已知 GUID 优先，旧模态名称仅作兜底。
export function isTextPreviewModality(guid, name) {
  if (guid === '049ad718737c485db227eca0272741e1') return true;
  if (['5aa07943e33345439fb4eead060812d0', 'dd0ba3b0214b4f0e8228b47c3b853b05',
    '22a7620401b341719d67503b6280e133'].includes(guid)) return false;
  return typeof name === 'string' && name.startsWith('文本');
}

// 独立实例不继承全局的长超时和错误拦截器，取消预览也不会影响其他页面请求。
const client = Axios.create({ baseURL: route, timeout: 60000, withCredentials: false });

function requestHeaders() {
  return {
    Authorization: localStorage.getItem('token') || '',
    appSideGuid: '03cb364e04d894a44cdb94273abffa13',
    'Content-Type': 'application/json;charset=UTF-8',
  };
}

// 仅预览工作区使用，失败由当前选择请求处理，避免全局拦截器弹出过期请求的错误。
export function requestPreviewTemplateDetail(guid) {
  return client.get(`/${serverConfig.msSalesPerformService}/label-template/edit-detail?guid=${encodeURIComponent(guid)}`,
    { headers: requestHeaders() });
}

// 每次打开从认证 API 取得当前环境的完整入口，不缓存或回退到浏览器中的其他地址。
export function requestPrelabelPreviewEntry() {
  const cancellation = Axios.CancelToken.source();
  const promise = client.get(`/${serverConfig.msSalesPerformService}/prelabel-model/preview-entry`, {
    headers: requestHeaders(), cancelToken: cancellation.token, timeout: 10000,
  }).then(response => {
    const result = response.data;
    if (!result || result.code !== serverConfig.REQUIRE_SUCCESS_CODE) {
      throw new Error(result && typeof result.msg === 'string' ? result.msg : '预览入口配置获取失败');
    }
    const address = result.data && result.data.url;
    let parsed;
    try {
      if (typeof address !== 'string' || !/^https?:\/\/[^/]/i.test(address) || /[\s\\?#]/.test(address)
        || /^https?:\/\/[^/]*@/i.test(address)) throw new Error();
      parsed = new URL(address);
    } catch (error) {
      throw new Error('预览入口未配置或地址无效，请联系管理员');
    }
    if (!['http:', 'https:'].includes(parsed.protocol) || !parsed.hostname || parsed.username || parsed.password
      || parsed.search || parsed.hash || !parsed.pathname.endsWith('/prelabel-preview/')) {
      throw new Error('预览入口未配置或地址无效，请联系管理员');
    }
    return parsed.href;
  }).catch(error => {
    if (Axios.isCancel(error)) throw error;
    if (error.code === 'ECONNABORTED') throw new Error('预览入口加载超时，请点击重试加载');
    if (error.response) {
      const message = error.response.data && error.response.data.msg;
      throw new Error(typeof message === 'string' ? message : '预览入口加载失败，请点击重试加载');
    }
    if (error.message === 'Network Error') throw new Error('无法获取预览入口，请点击重试加载');
    throw error;
  });
  return { promise, cancel: () => cancellation.cancel('本次预览入口已失效') };
}

export function requestPrelabelPreview(body) {
  const cancellation = Axios.CancelToken.source();
  // 共享请求过滤器经过 JVM 默认字符集；纯 ASCII 的 JSON 转义可原样承载中文、emoji 和换行。
  const payload = JSON.stringify(body).replace(/[\u0080-\uffff]/g,
    character => '\\u' + ('0000' + character.charCodeAt(0).toString(16)).slice(-4));
  const promise = client.post(`/${serverConfig.msSalesPerformService}/prelabel-model/preview`, payload, {
    cancelToken: cancellation.token,
    headers: requestHeaders(),
  }).then(response => {
    const result = response.data;
    if (!result || result.code !== serverConfig.REQUIRE_SUCCESS_CODE) {
      throw new Error(result && typeof result.msg === 'string' ? result.msg : '预览接口返回异常，请重试');
    }
    return result.data;
  }).catch(error => {
    if (Axios.isCancel(error)) throw error;
    if (error.code === 'ECONNABORTED') throw new Error('预标注超时（最多等待 60 秒），请重试');
    if (error.response) {
      const message = error.response.data && error.response.data.msg;
      throw new Error(typeof message === 'string' ? message : '预览服务请求失败，请重试');
    }
    if (error.message === 'Network Error') throw new Error('无法连接预览服务，请检查网络后重试');
    throw error;
  });
  return { promise, cancel: () => cancellation.cancel('本次预览已失效') };
}
